(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('assignAirCrew', {
                parent: 'app',
                url: '/assignAirCrew?departureDate&plaque',
                params: {
                    departureDate: null,
                    plaque: "all"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/assignAirCrew/assignAirCrews.html',
                        controller: 'assignAirCrewCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew','adminFlight','aircraft','generateFlight']);
                            }],
                            'assignAirCrews': ['assignAirCrewService','$stateParams', function(assignAirCrewService,$stateParams){
                                if ($stateParams.departureDate == null) {
                                    $stateParams.departureDate = (new Date()).getTime();
                                }

                                if($stateParams.departureDate != null && $stateParams.plaque == "all"){
                                    return assignAirCrewService.getAssingAirCrewByDate($stateParams.departureDate);
                                }else{
                                    return assignAirCrewService.getAssingAirCrewByDateAircraft($stateParams.departureDate, $stateParams.plaque);
                                }
                            }],
                            'plaqueAirCrafts': ['aircraftService', function (aircraftService) {
                                return aircraftService.getAircrafts()
                            }]
                        }
                    }
                }
            })
            .state('assignAirCrewEdit', {
                parent: 'app',
                url: '/assignAirCrewEdit/:id/edit/:ids',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/assignAirCrew/assignAirCrewNew.html',
                        controller: 'assignAirCrewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['adminFlight','stretch','aircrew','aircraft','structureSeatMap']);
                            }],
                            'assignAirCrewsLoadForm': ['assignAirCrewService', '$stateParams',
                                function (assignAirCrewService, $stateParams) {
                                    return assignAirCrewService.getLoadForm(parseInt($stateParams.id));
                                }]/*,
                            'assignAirCrews': ['assignAirCrewService', function (assignAirCrewService) {
                                return assignAirCrewService.getAssignAirCrew();
                            }]*/
                        }
                    }
                }
            })
    }
})();

